import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-aggregate-shares-validation",
  // imports: [],
  templateUrl: "./aggregate-shares-validation.component.html",
  styleUrl: "./aggregate-shares-validation.component.css",
  standalone: false,
})
export class AggregateSharesValidationComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
